import { defineMessages } from 'react-intl';
import { PLAN_ID_PPC_12M, PLAN_ID_PPC_1M, PLAN_ID_PP_1M, PLAN_ID_PP_12M } from '../../constants';

export const objectivesMessages = defineMessages({
  adFree: {
    id: 'index.plans-overview.p.ad-free',
    defaultMessage: 'On-demand and ad-free listening',
  },
  collection: {
    id: 'index.plans-overview.p.collection',
    defaultMessage: 'Unlimited personal collection of 2+ million tracks and exclusive releases',
  },
  weeklyMixes: {
    id: 'index.plans-overview.p.weekly-mixes',
    defaultMessage: 'Curated recommendations & weekly mixes',
  },
  quality: {
    id: 'index.plans-overview.pp.lossless',
    defaultMessage: 'Lossless audio quality (FLAC 16bit 44.1kHz)',
  },
  connect: {
    id: 'index.plans-overview.pp.connect',
    defaultMessage: 'Connect to Sonos and more',
  },
  concertAccess: {
    id: 'index.plans-overview.ppc.access',
    defaultMessage: 'Access all IDAGIO Concerts',
  },
});

export const planTitleMessages = defineMessages({
  [PLAN_ID_PP_1M]: {
    id: 'index.plans-overview.premium-plus.title',
    defaultMessage: 'Premium Audio',
  },
  [PLAN_ID_PP_12M]: {
    id: 'index.plans-overview.premium-plus-12m.title',
    defaultMessage: 'Premium Audio',
  },
  [PLAN_ID_PPC_1M]: {
    id: 'index.plans-overview.ppc-1m.title',
    defaultMessage: 'Premium Audio + Video',
  },
  [PLAN_ID_PPC_12M]: {
    id: 'index.plans-overview.ppc-12m.title',
    defaultMessage: 'Premium Audio + Video',
  },
});
